import { Component, inject } from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { LocalStorageService } from "@kernel/tools/services/local-storage.service";
import { AuthServiceImpl } from "@app/shared/authentication/services/auth.servcice";
import { SvgIconComponent } from "@kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { TranslatePipe } from "@ngx-translate/core";
import { ChatService } from "@app/shared/chat/services/chat.service";
import { CreditService } from "@app/shared/payment/services/credit.service";

@Component({
  selector: "app-bottom-nav",
  imports: [RouterLink, SvgIconComponent, RouterLinkActive, TranslatePipe],
  templateUrl: "./bottom-nav.component.html",
  styleUrl: "./bottom-nav.component.scss",
})
export class BottomNavComponent {
  private readonly router = inject(Router);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly authServiceImpl = inject(AuthServiceImpl);
  readonly chatService = inject(ChatService);
  readonly creditService = inject(CreditService);

  showUserMenu = false;

  toggleUserMenu(): void {
    this.showUserMenu = !this.showUserMenu;
  }

  closeUserMenu(): void {
    this.showUserMenu = false;
  }

  goToProfile(): void {
    this.closeUserMenu();
    this.router.navigate(["/profile"]);
  }

  goToBilling(): void {
    this.closeUserMenu();
    this.router.navigate(["/", "payment", "billing"]);
  }

  goToUpdateMyProperty(): void {
    this.closeUserMenu();
    this.router.navigate(["/", "my-request", "edit"]);
  }

  async logout(): Promise<void> {
    this.closeUserMenu();
    this.authServiceImpl.clearUser();
    this.localStorageService.remove("token");
    this.localStorageService.remove("user");
    await this.router.navigate(["/auth/login"]);
  }
}
